import React, { useState } from 'react';
import './search-popup.css';
import { MdCancel } from 'react-icons/md';
import TableContainer from '../../../Components/table/TableContainer';
import SearchBar from '../../../Components/search-bar/SearchBar';
import { CircularProgress } from '@mui/material';

function SearchPopup({ agents = [], onClose, onAgentSelect, feedback, title, loading = false}) {
  const [searchValue, setSearchValue] = useState('');

  const columns = [
    { field: 'code', headerName: 'Code' },
    { field: 'name', headerName: 'Name' },
  ];

  const rows = agents.map((item) => ({
    id: item.code,
    code: item.code,
    name: item.level ? `${item.name} (${item.level})` : item.name,
  }));

  const safeLower = (str) => (str ? str.toLowerCase() : '');

  const filteredRows = rows
    .filter(row =>
      safeLower(row.code).includes(safeLower(searchValue)) ||
      safeLower(row.name).includes(safeLower(searchValue))
    )
    .sort((a, b) => {
      return a.code.localeCompare(b.code, undefined, { numeric: true });
    });

  const handleRowClick = (row) => {
    if (typeof onAgentSelect === 'function') {
      onAgentSelect(row);
    }
    onClose();
  };

  return (
    <div className="search-popup">
      <div className="search-popup-content">
        <span className="popup-close" onClick={onClose}>
          <MdCancel color="#E30613" size={24} />
        </span>
        <div className="popup-body">
          <h3>{title || 'Select Option from List'}</h3>
          <SearchBar
            searchValue={searchValue}
            isReadOnly={false}
            onChange={(e) => setSearchValue(e.target.value)}
          />

          {loading ? (
            <div className="loading-overlay">
              <CircularProgress
                size={60}
                thickness={4.5}
                sx={{
                  color: 'linear-gradient(to right, red, blue)',
                }}
              />
            </div>
          ) : filteredRows.length > 0 ? (
            <TableContainer
              columns={columns}
              rows={filteredRows}
              initialSortingModel={[]}
              onRowClick={handleRowClick}
            />
          ) : (
            <p>{feedback?.message || 'No data found.'}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchPopup;
